import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserContext } from '../App';
import Logo from './Logo';
import Profile from './Profile';
import Nominees from './Beneficiaries';

export default function Account() {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const [tab, setTab] = useState('profile');
  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  if (!currentUser) return null;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 700);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const TabButton = ({ id, children }) => (
    <button
      onClick={() => setTab(id)}
      style={{
        padding: '10px 16px',
        border: 'none',
        borderBottom: tab === id ? '3px solid var(--sage-600)' : '3px solid transparent',
        background: 'transparent',
        color: tab === id ? 'var(--dusk-700)' : '#666',
        fontWeight: 600,
        cursor: 'pointer'
      }}
    >{children}</button>
  );

  const sidebarStyle = {
    width: 220,
    background: 'var(--dusk-700)',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    padding: '32px 0 18px 0',
    boxShadow: '2px 0 12px rgba(30,40,60,0.04)',
    position: 'fixed',
    left: 0,
    top: 0,
    height: '100vh',
    zIndex: 100,
  };
  const mobileSidebarStyle = {
    ...sidebarStyle,
    width: 180,
    minWidth: 0,
    maxWidth: '80vw',
    transition: 'transform 0.3s',
    transform: 'translateX(-100%)',
  };
  const mobileSidebarOpenStyle = {
    ...mobileSidebarStyle,
    transform: 'translateX(0)',
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--mist-100)' }}>
      {/* Mobile hamburger */}
      {isMobile && (
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          style={{ position: 'fixed', top: 18, left: 18, zIndex: 2100, background: 'var(--sage-600)', color: '#fff', border: 'none', borderRadius: 12, padding: '10px 12px', fontSize: 22, boxShadow: 'var(--shadow-soft)', cursor: 'pointer' }}
          aria-label="Open menu"
        >
          ☰
        </button>
      )}

      {/* Sidebar */}
      <nav
        style={
          isMobile
            ? (sidebarOpen ? mobileSidebarOpenStyle : mobileSidebarStyle)
            : sidebarStyle
        }
      >
        <div>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
            <Logo size={36} />
          </div>
          {/* User indicator */}
          <div style={{ background: 'var(--sage-600)', color: '#fff', borderRadius: 8, padding: '10px 16px', margin: '0 18px 18px 18px', fontSize: 15, fontWeight: 500, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2, boxShadow: 'var(--shadow-soft)' }}>
            <span>Logged in as:</span>
            <span style={{ fontWeight: 700 }}>{currentUser.name}</span>
            <span style={{ fontSize: 13, opacity: 0.85 }}>{currentUser.email}</span>
            {currentUser.role && <span style={{ fontSize: 13, opacity: 0.7 }}>({currentUser.role})</span>}
          </div>

          {/* Dashboard */}
          <div style={{ marginBottom: 24 }}>
            <button
              onClick={() => { navigate('/dashboard'); setSidebarOpen(false); }}
              style={{ background: location.pathname === '/dashboard' ? 'var(--sage-600)' : '#29304a', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 18px', fontWeight: location.pathname === '/dashboard' ? 600 : 500, fontSize: 16, margin: '0 18px', width: 'calc(100% - 36px)', cursor: 'pointer', textAlign: 'left', outline: 'none', boxShadow: location.pathname === '/dashboard' ? 'var(--shadow-soft)' : 'none' }}
            >
              Dashboard
            </button>
          </div>

          {/* Assets Section */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#888', margin: '0 18px 8px 18px', textTransform: 'uppercase', letterSpacing: 0.5 }}>Assets</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <button
                onClick={() => { navigate('/financial-assets'); setSidebarOpen(false); }}
                style={{ background: location.pathname === '/financial-assets' ? 'var(--sage-600)' : '#29304a', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 18px', fontWeight: location.pathname === '/financial-assets' ? 600 : 500, fontSize: 16, margin: '0 18px', width: 'calc(100% - 36px)', cursor: 'pointer', textAlign: 'left', outline: 'none', boxShadow: location.pathname === '/financial-assets' ? 'var(--shadow-soft)' : 'none' }}
              >
                Financial Assets
              </button>
              <button
                onClick={() => { navigate('/legal-assets'); setSidebarOpen(false); }}
                style={{ background: location.pathname === '/legal-assets' ? 'var(--sage-600)' : '#29304a', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 18px', fontWeight: location.pathname === '/legal-assets' ? 600 : 500, fontSize: 16, margin: '0 18px', width: 'calc(100% - 36px)', cursor: 'pointer', textAlign: 'left', outline: 'none', boxShadow: location.pathname === '/legal-assets' ? 'var(--shadow-soft)' : 'none' }}
              >
                Legal Assets
              </button>
              <button
                onClick={() => { navigate('/other-assets'); setSidebarOpen(false); }}
                style={{ background: location.pathname === '/other-assets' ? 'var(--sage-600)' : '#29304a', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 18px', fontWeight: location.pathname === '/other-assets' ? 600 : 500, fontSize: 16, margin: '0 18px', width: 'calc(100% - 36px)', cursor: 'pointer', textAlign: 'left', outline: 'none', boxShadow: location.pathname === '/other-assets' ? 'var(--shadow-soft)' : 'none' }}
              >
                Other Assets
              </button>
            </div>
          </div>

          {/* Account Section */}
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#888', margin: '0 18px 8px 18px', textTransform: 'uppercase', letterSpacing: 0.5 }}>Account</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <button
                onClick={() => { navigate('/account'); setSidebarOpen(false); }}
                style={{ background: location.pathname === '/account' ? 'var(--sage-600)' : '#29304a', color: '#fff', border: 'none', borderRadius: 12, padding: '12px 18px', fontWeight: location.pathname === '/account' ? 600 : 500, fontSize: 16, margin: '0 18px', width: 'calc(100% - 36px)', cursor: 'pointer', textAlign: 'left', outline: 'none', boxShadow: location.pathname === '/account' ? 'var(--shadow-soft)' : 'none' }}
              >
                Account
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main */}
      <div style={{ flex: 1, marginLeft: isMobile ? 0 : 220, padding: isMobile ? '60px 0 0 0' : '0 0 0 0', minHeight: '100vh', overflow: 'auto' }}>
        <div style={{ maxWidth: 960, margin: '0 auto', padding: '20px 20px 40px' }}>
          <div style={{ display: 'flex', gap: 16, borderBottom: '1px solid var(--mist-300)', marginBottom: 16 }}>
            <TabButton id="profile">Your profile</TabButton>
            <TabButton id="nominees">Nominees</TabButton>
          </div>
          <div>
            {tab === 'profile' && (
              <Profile embedded />
            )}
            {tab === 'nominees' && (
              <Nominees embedded />
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
            <button
              onClick={() => { setCurrentUser(null); navigate('/login'); }}
              style={{ background: 'var(--sage-600)', color: '#fff', border: 'none', borderRadius: 12, padding: '10px 14px', fontWeight: 600, cursor: 'pointer' }}
            >Log out</button>
          </div>
        </div>
      </div>
    </div>
  );
}


